// ===== FORM FIELD CONFIGURATIONS =====
// Form field definitions for all admin dashboard entities
// Extracted from Dashboard.tsx for better maintainability

import type { FormField } from '../components/common';

// ===== EXCEL HARDCODED LISTS FORM FIELDS =====

export const equipmentBrandFormFields: FormField[] = [
  {
    key: 'equipmentType',
    label: 'Tipo de Equipo',
    type: 'select',
    required: true,
    width: '200px',
    options: [
      { value: 'zaranda', label: 'Zaranda' },
      { value: 'desarenador', label: 'Desarenador' },
      { value: 'desilter', label: 'Desilter' },
      { value: 'secadora', label: 'Secadora' },
      { value: 'decanter', label: 'Decanter' }
    ]
  },
  {
    key: 'brand',
    label: 'Marca',
    type: 'text',
    required: true,
    placeholder: 'ej: SWACO, DERRICK',
    width: '250px'
  },
  {
    key: 'model',
    label: 'Modelo',
    type: 'text',
    placeholder: 'Modelo (opcional)',
    width: '200px'
  }
];

export const dischargeTypeFormFields: FormField[] = [
  {
    key: 'type',
    label: 'Tipo de Descarga',
    type: 'text',
    required: true,
    placeholder: 'ej: Continua, Intermitente, Manual',
    width: '250px'
  },
  {
    key: 'description',
    label: 'Descripción',
    type: 'text',
    placeholder: 'Descripción opcional',
    width: '300px'
  }
];

export const screenTypeFormFields: FormField[] = [
  {
    key: 'mesh',
    label: 'Mesh',
    type: 'number',
    required: true,
    placeholder: 'ej: 40, 60, 100',
    width: '150px',
    min: 1,
    max: 1000
  },
  {
    key: 'description',
    label: 'Descripción API',
    type: 'text',
    required: true,
    placeholder: 'ej: API RP 13C - 40 mesh',
    width: '300px'
  }
];

export const empresaFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre de la Empresa',
    type: 'text',
    required: true,
    placeholder: 'ej: MARBAR, TECPETROL, YPF',
    width: '250px'
  },
  {
    key: 'codigo',
    label: 'Código',
    type: 'text',
    required: true,
    placeholder: 'ej: marbar, tecpetrol, ypf',
    width: '200px'
  },
  {
    key: 'numeroContrato',
    label: 'Número de Contrato',
    type: 'text',
    placeholder: 'ej: LP-001-2024',
    width: '200px'
  }
];

// ===== REPORT MANAGEMENT FORM FIELDS =====

export const dailyActivityFormFields: FormField[] = [
  {
    key: 'name',
    label: 'Actividad',
    type: 'text',
    required: true,
    placeholder: 'ej: Perfora',
    width: '200px'
  }
];

export const mudTypeFormFields: FormField[] = [
  {
    key: 'type',
    label: 'Tipo de Lodo',
    type: 'select',
    required: true,
    width: '150px',
    options: [
      { value: 'WBM', label: 'WBM (Base Agua)' },
      { value: 'OBM', label: 'OBM (Base Aceite)' },
      { value: 'SBM', label: 'SBM (Base Sintético)' }
    ]
  },
  {
    key: 'displayName',
    label: 'Nombre a Mostrar',
    type: 'text',
    required: true,
    placeholder: 'ej: Bentonítico, Cálcico',
    width: '200px'
  },
  {
    key: 'description',
    label: 'Descripción',
    type: 'text',
    placeholder: 'Descripción opcional',
    width: '300px'
  }
];

export const phaseOleosaFormFields: FormField[] = [
  {
    key: 'name',
    label: 'Nombre',
    type: 'text',
    required: true,
    placeholder: 'ej: Gasoil, Sintético, Neoflo',
    width: '200px'
  },
  {
    key: 'density',
    label: 'Densidad (g/L)',
    type: 'number',
    required: true,
    placeholder: 'ej: 840',
    width: '150px'
  }
];

export const densificanteFormFields: FormField[] = [
  {
    key: 'material',
    label: 'Material',
    type: 'text',
    required: true,
    placeholder: 'ej: Baritina, Carbonato',
    width: '200px'
  },
  {
    key: 'density',
    label: 'Densidad (g/L)',
    type: 'number',
    required: true,
    placeholder: 'ej: 4200',
    width: '150px'
  }
];

// ===== COMPANY & EQUIPMENT FORM FIELDS =====

export const operadoraFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre de la Operadora',
    type: 'text',
    required: true,
    placeholder: 'ej: YPF, Shell, Total',
    width: '300px'
  },
  {
    key: 'color',
    label: 'Color Corporativo',
    type: 'text',
    required: true,
    placeholder: 'ej: #56B046, #0065BD, #FF0000',
    width: '200px'
  },
  {
    key: 'empresa',
    label: 'Empresa',
    type: 'text',
    required: false,
    placeholder: 'ej: marbar, otra',
    width: '200px'
  }
];

export const equipoFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre del Equipo',
    type: 'text',
    required: true,
    placeholder: 'ej: Equipo 101, Rig 205',
    width: '300px'
  },
  {
    key: 'operadoraId',
    label: 'Operadora',
    type: 'select',
    required: true,
    width: '250px',
    options: [] // Will be populated dynamically
  }
];

// ===== FIELD OPERATIONS FORM FIELDS =====

export const padFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre del Pad',
    type: 'text',
    required: true,
    placeholder: 'ej: Pad A-1, Locación Norte',
    width: '250px'
  },
  {
    key: 'operadoraId',
    label: 'Operadora',
    type: 'select',
    required: true,
    width: '200px',
    options: [] // Will be populated dynamically
  },
  {
    key: 'equipoId',
    label: 'Equipo',
    type: 'select',
    required: true,
    width: '200px',
    options: [] // Will be populated dynamically
  }
];

export const pozoFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre del Pozo',
    type: 'text',
    required: true,
    placeholder: 'ej: YPF-001, Shell-102',
    width: '250px'
  },
  {
    key: 'padId',
    label: 'Pad',
    type: 'select',
    required: true,
    width: '200px',
    options: [] // Will be populated dynamically
  },
  {
    key: 'comprobanteBase',
    label: 'Código Base Comprobante',
    type: 'text',
    required: false,
    placeholder: 'ej: NQN-CS-03-0144 B',
    width: '250px'
  }
];

export const tramoFormFields: FormField[] = [
  {
    key: 'fase',
    label: 'Fase',
    type: 'text',
    required: true,
    placeholder: 'ej: Guía, Intermedia, Producción',
    width: '200px'
  },
  {
    key: 'tamanioTrepan',
    label: 'Tamaño del Trepano',
    type: 'text',
    required: true,
    placeholder: 'ej: 17 1/2", 12 1/4"',
    width: '150px'
  },
  {
    key: 'profundidadObjetivo',
    label: 'Profundidad Objetivo (m)',
    type: 'number',
    required: true,
    placeholder: 'ej: 2500',
    width: '180px',
    min: 0
  }
];

export const trepanoFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre del Trepano',
    type: 'text',
    required: true,
    placeholder: 'ej: PDC-001, Tricono-205',
    width: '250px'
  },
  {
    key: 'tamanio',
    label: 'Tamaño',
    type: 'text',
    required: true,
    placeholder: 'ej: 17 1/2", 12 1/4"',
    width: '150px'
  }
];

// ===== TANK MANAGEMENT FORM FIELDS =====

export const piletaTipoFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Tipo de Pileta',
    type: 'text',
    required: true,
    placeholder: 'ej: Lodo Activo, Reserva, Descarte',
    width: '250px'
  },
  {
    key: 'tabla',
    label: 'Tabla de Volúmenes',
    type: 'text',
    required: true,
    placeholder: 'ej: tabla_500_bbl (sin .csv)',
    width: '300px'
  }
];

export const piletaEquipoFormFields: FormField[] = [
  {
    key: 'nombre',
    label: 'Nombre de la Pileta',
    type: 'text',
    required: true,
    placeholder: 'ej: Pileta 1, Tank A',
    width: '200px'
  },
  {
    key: 'serial',
    label: 'Número de Serie',
    type: 'text',
    required: true,
    placeholder: 'ej: TNK-001-2024',
    width: '200px'
  },
  {
    key: 'tipoId',
    label: 'Tipo de Pileta',
    type: 'select',
    required: true,
    width: '200px',
    options: [] // Will be populated dynamically
  }
];

// ===== MATERIALS & SERVICES FORM FIELDS =====

export const materialFormFields: FormField[] = [
  {
    key: 'codigoMarbar',
    label: 'Código Marbar',
    type: 'text',
    required: true,
    placeholder: 'ej: MAT-001',
    width: '150px'
  },
  {
    key: 'nombreComercial',
    label: 'Nombre Comercial',
    type: 'text',
    required: true,
    placeholder: 'ej: Barita Premium',
    width: '250px'
  },
  {
    key: 'unidad',
    label: 'Unidad',
    type: 'select',
    required: true,
    width: '100px',
    options: [
      { value: 'kg', label: 'kg' },
      { value: 'l', label: 'l' },
      { value: 'm3', label: 'm³' },
      { value: 'día', label: 'día' },
      { value: 'serv', label: 'serv' },
      { value: 'uu', label: 'uu' }
    ]
  },
  {
    key: 'costoUnitario',
    label: 'Costo Unitario',
    type: 'number',
    required: true,
    placeholder: '0.00',
    width: '120px',
    min: 0,
    step: 0.01
  },
  {
    key: 'categoria',
    label: 'Categoría',
    type: 'select',
    required: true,
    width: '150px',
    options: [
      { value: 'densificante', label: 'Densificante' },
      { value: 'viscosificante', label: 'Viscosificante' },
      { value: 'fluido', label: 'Fluido' },
      { value: 'aditivo', label: 'Aditivo' },
      { value: 'sal', label: 'Sal' }
    ]
  }
];

export const servicioTipoFormFields: FormField[] = [
  {
    key: 'empresaCodigo',
    label: 'Empresa',
    type: 'select',
    required: false,
    width: '200px',
    options: [] // Will be populated dynamically from empresas collection
  },
  {
    key: 'item',
    label: 'ITEM',
    type: 'text',
    placeholder: 'ej: 1, 2, 3',
    width: '80px'
  },
  {
    key: 'subItem',
    label: 'SUB ITEM',
    type: 'text',
    placeholder: 'ej: 1.1, 2.3',
    width: '100px'
  },
  {
    key: 'codigoMarbar',
    label: 'Código MARBAR',
    type: 'text',
    placeholder: 'ej: 006001000000001',
    width: '180px'
  },
  {
    key: 'descripcion',
    label: 'Descripción',
    type: 'text',
    required: true,
    placeholder: 'Descripción del servicio',
    width: '300px'
  },
  {
    key: 'costoUnitario',
    label: 'Costo Unitario',
    type: 'number',
    required: true,
    placeholder: '0.00',
    width: '120px',
    min: 0,
    step: 0.01
  },
  {
    key: 'unidadCobro',
    label: 'Unidad de Cobro',
    type: 'select',
    required: true,
    width: '120px',
    options: [
      { value: 'día', label: 'día' },
      { value: 'serv', label: 'serv' },
      { value: 'hr', label: 'hr' },
      { value: 'uu', label: 'uu' },
      { value: 'km', label: 'km' },
      { value: 'kg', label: 'kg' },
      { value: 'l', label: 'l' }
    ]
  }
];

// ===== API MESH/SCREENS MANAGEMENT FORM FIELDS =====

export const apiMeshFormFields: FormField[] = [
  {
    key: 'mesh',
    label: 'API Mesh',
    type: 'number',
    required: true,
    placeholder: 'ej: 40, 60, 100',
    width: '150px',
    min: 10,
    max: 1000
  },
  {
    key: 'description',
    label: 'Descripción API',
    type: 'text',
    required: true,
    placeholder: 'ej: API RP 13C - 40 mesh',
    width: '300px'
  },
  {
    key: 'equipmentType',
    label: 'Equipo Aplicable',
    type: 'select',
    required: true,
    width: '200px',
    options: [
      { value: 'zaranda1', label: 'Zaranda 1' },
      { value: 'zaranda2', label: 'Zaranda 2' },
      { value: 'zaranda3', label: 'Zaranda 3' },
      { value: 'secadora1', label: 'Secadora 1' },
      { value: 'secadora2', label: 'Secadora 2' },
      { value: 'secadora3', label: 'Secadora 3' }
    ]
  },
  {
    key: 'stockInicial',
    label: 'Stock Inicial',
    type: 'number',
    required: true,
    placeholder: '0',
    width: '150px',
    min: 0
  }
];

export const meshMovementFormFields: FormField[] = [
  {
    key: 'meshId',
    label: 'Malla API',
    type: 'select',
    required: true,
    width: '200px'
    // options will be populated dynamically from available meshes
  },
  {
    key: 'movementType',
    label: 'Tipo Movimiento',
    type: 'select',
    required: true,
    width: '180px',
    options: [
      { value: 'recibido', label: 'Recibido' },
      { value: 'transferido', label: 'Transferido' },
      { value: 'consumido', label: 'Consumido' },
      { value: 'devuelto', label: 'Devuelto' }
    ]
  },
  {
    key: 'cantidad',
    label: 'Cantidad',
    type: 'number',
    required: true,
    placeholder: '0',
    width: '120px',
    min: 0
  },
  {
    key: 'equipmentId',
    label: 'Equipo',
    type: 'select',
    required: false,
    width: '150px',
    options: [
      { value: 'zaranda1', label: 'Zaranda 1' },
      { value: 'zaranda2', label: 'Zaranda 2' },
      { value: 'zaranda3', label: 'Zaranda 3' },
      { value: 'secadora1', label: 'Secadora 1' },
      { value: 'secadora2', label: 'Secadora 2' },
      { value: 'secadora3', label: 'Secadora 3' }
    ]
  },
  {
    key: 'observaciones',
    label: 'Observaciones',
    type: 'text',
    placeholder: 'Comentarios opcionales',
    width: '300px'
  }
];

export const bowlSizeFormFields: FormField[] = [
  {
    key: 'size',
    label: 'Tamaño de Bowl',
    type: 'text',
    required: true,
    placeholder: 'ej: 14", 16", 18", 20"',
    width: '150px'
  },
  {
    key: 'description',
    label: 'Descripción',
    type: 'text',
    placeholder: 'Descripción opcional',
    width: '250px'
  }
];

export const coneCountFormFields: FormField[] = [
  {
    key: 'equipmentType',
    label: 'Tipo de Equipo',
    type: 'select',
    required: true,
    width: '200px',
    options: [
      { value: 'desarenador', label: 'Desarenador' },
      { value: 'desilter', label: 'Desilter' }
    ]
  },
  {
    key: 'count',
    label: 'Cantidad de Conos',
    type: 'number',
    required: true,
    placeholder: '1-4 para desarenador, 12-18 para desilter',
    width: '200px'
  },
  {
    key: 'description',
    label: 'Descripción',
    type: 'text',
    placeholder: 'Descripción opcional',
    width: '250px'
  }
];

// ===== EXCEL REPORTING FORM FIELDS =====
// TODO: Extract these from Dashboard.tsx in the next phase
